import React from "react";

const SUCCESS = "success"
const FAIL = "fail"
const styles = {
    textStyle: {
        fontSize: 18,
        weight: 800
    },
    successStyle: {
        color: "#702f8a"
    },
    failStyle: {
        color: "#535353"
    }
}

const Text = props => {
    if (props.value === SUCCESS) {
        return (
            <div className="text" align="center">
                <h2 className="title-1">Successful</h2>
                <p style={{...styles.textStyle, ...styles.successStyle}}>
                    Your payment instruction has been received and is being processed
                </p>
            </div>
        )
    } else if (props.value === FAIL) {
        return (
            <div className="text" align="center">
                <h2 className="title-1">Error</h2>
                <p style={{...styles.textStyle, ...styles.failStyle}}>
                    There has been a problem in processing your payment instruction
                </p>
            </div>
        )
    } else {
        return <div></div>
    }
}

export default Text;
